export const feedbackConfigSchema = {
    type: 'object',
    properties: {
        hide: {
            type: 'boolean',
            default: false,
        },
        type: {
            type: 'string',
            enum: ['rating', 'sentiment', 'comment', 'reasons', 'mood', 'scale'],
            default: 'sentiment',
        },
        settings: {
            type: 'object',
            properties: {
                label: { type: 'string' },
                submitText: { type: 'string' },
                buttonText: { type: 'string' },
                component: {
                    type: 'string',
                    enum: ['radio', 'checkbox'],
                    default: 'checkbox',
                },
                items: { type: 'array', items: { type: 'string' }, minItems: 1 },
                leftScaleLabel: { type: 'string' },
                rightScaleLabel: { type: 'string' },
                reasons: {
                    type: 'object',
                    properties: {
                        hide: {
                            type: 'boolean',
                            default: false,
                        },
                        component: {
                            type: 'string',
                            enum: ['radio', 'checkbox'],
                            default: 'checkbox',
                        },
                        label: { type: 'string' },
                        items: { type: 'array', items: { type: 'string' } },
                    },
                    additionalProperties: false,
                },
                comment: {
                    type: 'object',
                    properties: {
                        hide: {
                            type: 'boolean',
                            default: false,
                        },
                        label: { type: 'string' },
                        likeLabel: { type: 'string' },
                        dislikeLabel: { type: 'string' },
                        satisfiedLabel: { type: 'string' },
                        neutralLabel: { type: 'string' },
                        dissatisfiedLabel: { type: 'string' },
                    },
                    additionalProperties: false,
                },
            },
            additionalProperties: false,
        },
    },
    additionalProperties: false,
    default: null,
    nullable: true,
};
//# sourceMappingURL=feedback-config-schema.js.map